export const lexicalSorter = (right: { id: string; date: string }, left: { id: string; date: string }) =>
  right.date.localeCompare(left.date);
